import infiniteProductSearchMixin from './infiniteProductSearchMixin';
import { defaultPaginationStrategy } from './strategies';

const defaultInfiniteProductSearchMixin = infiniteProductSearchMixin(defaultPaginationStrategy);

export {
  // eslint-disable-next-line import/prefer-default-export
  defaultInfiniteProductSearchMixin,
};
